import { Component,
    Output,
    Input,
    EventEmitter,
    ElementRef,
    Renderer,
    OnChanges,
    ViewChild,
    ViewEncapsulation
} from '@angular/core';
import { TranslateService, TranslatePipe, LangChangeEvent } from '@ngx-translate/core';
import { GlobalVariables } from '../../../../../../../common/global-variables';
import { TreeComponent, TreeService, TreeNode } from '../../../../../../../common/tree';
import { Service } from '../out-of-place-restore.service';
import { Subscription } from 'rxjs/Rx';
import { RestoreTreeConstants } from '../out-of-place-restore-constants';

@Component({
    selector: 'step-1',
    providers: [ Service, TreeService ],
    styles: [
        require('./step-1.scss')
    ],
    encapsulation: ViewEncapsulation.None,
    template: require('./step-1.html')
})

export class VmDestinationFolderTree implements OnChanges {
    @Input() vcId: String;
    @Output() onNewNameInputChange = new EventEmitter();
    @Output() onDestinationSelection = new EventEmitter();

    private url: String = "/hybridity/api/vc/query?";
    private subscription: Subscription;

    private options = {
        idField: 'entity_id',
        displayField: 'name',
        getChildren: this.getChildren.bind(this),
        getIconClass: this.getIconClass.bind(this),
        isExpandedField: 'expanded',
        hasContextMenu: true,
        contextMenuActionMapping: {},
        menuLinksMapping: {}
    };

    private nodes = [];
    private name: String;

    private destination = {
        'folder': '',
        'datacenter': {
            'name': '',
            'entity_id': ''
        },
        'path': ''
    };

    @ViewChild(TreeComponent)
    private tree: TreeComponent;

    constructor(public outOfPlaceRestoreService: Service, private elementRef: ElementRef,
                private renderer: Renderer, private translate: TranslateService,
                private treeService: TreeService) {
        translate.use(GlobalVariables.LOCALE);
    }

    getElementReference() {
        return this.elementRef;
    }

    ngOnChanges(changes) {
        if (changes && changes.vcId && changes.vcId.currentValue) {
            this.subscription =
            this.outOfPlaceRestoreService.getTreeNodes(this.getUrl('group-d1', this.vcId, 'vcenter')).subscribe((nodes:any) => {
                    this.nodes = nodes;
                },
                error => { console.log('Error on loading tree'); },
                () => {}
            );
        }
    }

    ngOnDestroy() {
        if( this.subscription ) {
            this.subscription.unsubscribe();
        }
    }

    getChildren(node) {
        let parentId: String = node.data.entity_id;
        let entityType: String = node.data.entityType;

        return this.outOfPlaceRestoreService.getChildNodes(this.getUrl(parentId, this.vcId, entityType));
    }

    getUrl(parentId, vcId, entityType) {
        return this.url + RestoreTreeConstants.getFolderViewChildrenQueryParameters(entityType)
                    + '&filter=parentId==' + parentId + ';vcenterId==' + vcId;
    }

    getIconClass(node) {
    }

    onNameInputChange() {
        if (this.name && this.name !== '') {
            this.onNewNameInputChange.emit(this.name);
        } else {
            this.onNewNameInputChange.emit();
        }
    }

    onNodeSelection = (event) => {
        let isValid = false;
        let node = event.node;
        let vmFolder = '';
        while (node && node.level > 0) {
            if (node.data && node.data.entityType === 'datacenter') {
                isValid = true;
                vmFolder = (vmFolder !== '') ? vmFolder : '/';
                this.destination.datacenter.entity_id = node.data.entity_id;
                this.destination.datacenter.name = node.data.name;
                this.destination.folder = vmFolder;
                break;
            } else {
                vmFolder = '/' + node.data.name + vmFolder;
                node = node.parent;
            }
        }
        if (isValid) {
            let vmPath = '/vm';
            while (node && node.level > 0) {
                vmPath = '/' + node.data.name + vmPath;
                node = node.parent;
            }
            this.destination.path = vmPath + this.destination.folder;
            this.onDestinationSelection.emit(this.destination);
        } else {
            this.onDestinationSelection.emit();
        }
    };

    onEvent = ($event) => {
    };

    onTreeInit = ($event) => {
        console.log('Tree Initialised');
    };

    onFocus = ($event) => {
    };
}



// WEBPACK FOOTER //
// ./src/app/components/dataprotection/dataprotection-vc/common-ops/out-of-place-restore/step-1/step-1.component.ts